module.exports = __webpack_public_path__ + "static/media/level-6.20d7d947.png";